import { SET_REQUEST, REMOVE_REQUEST } from '@/store/mutations.js';
import apiRequest from '@/js/helpers/apiRequest.js';

export default {
  state: {
    request: {}
  },

  mutations: {
    [SET_REQUEST]: (state, { request }) => {
      state.request = request;
    },

    [REMOVE_REQUEST]: state => {
      state.request = {};
    }
  },

  actions: {
    createRequest: async ({ commit }, { languageId, levelId }) => {
      const body = new FormData();
      body.append('language_id', languageId);
      body.append('level_id', levelId);

      const res = await apiRequest('request', 'POST', body, true);

      if (res.error) {
        throw { customeError: res.error };
      }

      const { id, end, language_id, level_id, teachers_count } = res.success;

      const request = {
        id,
        end,
        languageId: language_id,
        levelId: level_id,
        teachersCount: teachers_count
      };

      commit(SET_REQUEST, { request });
    },

    removeRequest: async ({ commit }, { id }) => {
      const res = await apiRequest(`request/cancel/${id}`, 'POST', null, true);

      if (res.error) {
        throw { customeError: res.error };
      }

      commit(REMOVE_REQUEST);
    }
  }
};
